<template>
  <div class="search_profit">
    <div style="text-align:center">
        <div class="protitle">《{{titles}}》自媒体分发预计评估收益报告</div>
        <div class="prosubtitle">报告生成日期<span>{{dataInit}}</span></div>
    </div>
    <Form id="profromid" ref="form" :model="form" :label-width="140">
        <Form-item label="预计可分发条数" prop="title">
            <div style="margin-left:20px;width:100%;margin-top: 1px;">{{form.brancheNum}}条</div>
        </Form-item>
        <Form-item label="预计收益周期" prop="copyrightType">
            <div style="margin-left:20px;width:100%;margin-top: 1px;">{{form.startTime}}<span style="margin:0 10px;">-</span>{{form.endTime}}</div>
        </Form-item>
        <Form-item label="预计收益金额" prop="releaseDate">
            <div style="margin-left:20px;color:#f00;font-size:16px;margin-top: 2px;">￥{{form.result}}</div>
        </Form-item>
    </Form>
    <div class="profot">
        <div class="profottil" style="font-size:20px;font-weight:550;">可分发平台</div>
        <div>
            <img style="width:62px;height:62px;margin:20px;" v-for="(item,i) in imageList" :key="i" :src="item" />
        </div>
    </div>
    <div style="color:#f00;text-align:center;margin-top:20px">
        注:本预估收益报告只可以做参考使用，具体收益请以实际情况为准。
    </div>
  </div>
</template>

<script>

import {} from "@/api/index";
export default {
  name: "profit_assess_detail",
  components: {
  },
  data() {
    return {
      dataInit:'',
      titles:'',
      form: { // 添加或编辑表单对象初始化数据
        brancheNum:'',
        startTime:'',
        endTime:'',
        result:'',
      },
      imageList:[
          require("@/assets/sh1.png"),
          require("@/assets/sh2.png"),
          require("@/assets/sh3.png"),
          require("@/assets/sh4.png"),
          require("@/assets/sh5.png"),
          require("@/assets/sh6.png"),
        //   require("@/assets/sh7.png"),
          require("@/assets/sh8.png"),
          require("@/assets/sh9.png"),
          require("@/assets/sh10.png"),
          require("@/assets/sh11.png"),
          require("@/assets/sh12.png"),
          require("@/assets/sh13.png"),
          require("@/assets/sh14.png"),
      ]
    };
  },
  methods: {
    init() {
      let dataInits = new Date();
      this.titles = this.$route.query.title;
      this.dataInit = this.time(dataInits) 
      this.getbugdetData()
    },
    time(date){
        var y = date.getFullYear();  
        var m = date.getMonth() + 1;  
        m = m < 10 ? '0' + m : m;  
        var d = date.getDate();  
        d = d < 10 ? ('0' + d) : d;  
        return y + '-' + m + '-' + d;  
    },
    formatMoney(number, places, thousand, decimal) {
        number = number || 0;
        places = !isNaN(places = Math.abs(places)) ? places : 2;
        thousand = thousand || ",";
        decimal = decimal || ".";
        var negative = number < 0 ? "-" : "",
            i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
            a = i.length,
            j = a > 3 ? a % 3 : 0;
        return negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
    },
    getbugdetData(){
        let sobject = this.$route.query
        sobject.releaseDate = this.time(new Date())
        sobject.minuteNum = parseInt(sobject.minuteNum)
        this.postRequest("/incomeBudgetAnalyse/budgetCalculate", sobject).then(res => {
            if (res.message == 'success') {
                this.$Message.success("预估成功");
                let array = JSON.parse(res.result)
                array.result = this.formatMoney(array.result)
                this.form = array
                console.log('+++++++++++++++++',array)
            }
        });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
    .search_profit{
        background:#fff;
        width: 800px;
        border-radius: 5px;
        margin: 50px auto;
        padding: 30px;
    }
    #profromid{
        display:flex;
        justify-content:center;
        flex-direction: column;
        .ivu-form-item-label{
            text-align:left;
            font-size:15px;
        }
    }
    .protitle{
        font-size: 22px;
        font-weight: 550;
        margin-bottom: 7px;
    }
    .prosubtitle{
        font-weight: 550;
        margin-bottom: 40px;
        span{
            margin-left: 20px;
        }
    }
    .profot{
        margin-top: 30px;
        border-top: 2px solid #000;
        .profottil{
            padding-top:30px;
        }
    }
</style>